import { useState, useEffect } from "react";
import { message } from "antd";
import { app } from "../../service/serviceLMS";

export const useQuizReport = ({ urlUserId, urlCourseId }) => {
  const [users, setUsers]   = useState([]);
  const [courses, setCourses] = useState([]);
  const [coursesFetched, setCoursesFetched] = useState(false);

  const [selectedUser, setSelectedUser]     = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const [userReport, setUserReport]     = useState([]);
  const [courseReport, setCourseReport] = useState([]);

  const [loadingFilters, setLoadingFilters] = useState(false);
  const [loadingReport, setLoadingReport]   = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoadingFilters(true);
      try {
        const usersRes = await app.get("/user/api/client-api/admin/active-employees");
        const fetchedUsers = usersRes.data.data;
        setUsers(fetchedUsers);

        if (urlUserId) {
          const parsed = parseInt(urlUserId);
          if (fetchedUsers.find((u) => u.userId === parsed)) {
            handleUserChange(parsed);
          }
        }
      } catch {
        message.error("Error fetching users");
      } finally {
        setLoadingFilters(false);
      }
    };

    fetchUsers();
  }, []);

  const fetchCoursesIfNeeded = async () => {
    if (coursesFetched) return; 
    setLoadingFilters(true);
    try {
      const coursesRes = await app.get("/course/api/client-api/course");
      const fetchedCourses = coursesRes.data.data;
      setCourses(fetchedCourses);
      setCoursesFetched(true);

      if (urlCourseId) {
        const parsed = parseInt(urlCourseId);
        if (fetchedCourses.find((c) => c.courseId === parsed)) {
          handleCourseChange(parsed);
        }
      }
    } catch {
      message.error("Error fetching courses");
    } finally {
      setLoadingFilters(false);
    }
  };

  const handleUserChange = async (userId) => {
    setSelectedUser(userId ?? null);
    if (!userId) {
      setUserReport([]);
      return;
    }
    setLoadingReport(true);
    try {
      const res = await app.get(
        `/course/api/client-api/quiz-attempt/quiz-attempt-details/${userId}`
      );
      setUserReport(res.data.data);
    } catch {
      message.error("Failed to load user quiz attempts");
    } finally {
      setLoadingReport(false);
    }
  };

  const handleCourseChange = async (courseId) => {
    setSelectedCourse(courseId ?? null);
    if (!courseId) {
      setCourseReport([]);
      return;
    }
    setLoadingReport(true);
    try {
      const res = await app.get(
        `/course/api/client-api/quiz-attempt/quiz-attempt-details/course/${courseId}`
      );
      const enriched = res.data.data.map((report) => {
        const sortedAttempts = [...report.userQuizAttemptDetailsOutDTOS].sort(
          (a, b) => b.quizAttempt.attempt - a.quizAttempt.attempt
        );
        return { ...report, latestAttempt: sortedAttempts[0] };
      });
      setCourseReport(enriched);
    } catch {
      message.error("Failed to load course quiz attempts");
    } finally {
      setLoadingReport(false);
    }
  };

  return {
    users,
    courses,
    userReport,
    courseReport,
    selectedUser,
    selectedCourse,
    loadingFilters,
    loadingReport,
    handleUserChange,
    handleCourseChange,
    fetchCoursesIfNeeded,
  };
};